import React, {Component} from 'react';
import {Card} from "react-bootstrap";
import "./navigation_card_ii.scss";
import {insertHtml} from "../../../utils/dom";

interface NavigationCardIIProps {
    title: string;
    text: string;
    url: string;
    cta_label: string;
    hidden: boolean;
}

class NavigationCardII extends Component<NavigationCardIIProps> {

    render() {

        let text = this.props.text;
        text = text.trim();

        return (
            <Card className={(this.props.hidden ? "hidden" : "")}>
                <Card.Body>
                    <Card.Title>{this.props.title}</Card.Title>
                    <Card.Text className="card-text-html" {...insertHtml(text)} />
                    <Card.Link href={this.props.url}>
                        { this.props.cta_label ? this.props.cta_label : "Scopri di più" }
                    </Card.Link>
                </Card.Body>
            </Card>
        );
    }
}

export default NavigationCardII;
